import React from 'react';
import { Link } from 'react-router-dom';

const PlayIcon = () => (
  <svg className="w-16 h-16" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="36.5" cy="36.5" r="36.5" fill="#D81C64"/>
    <polygon points="39.5 24.5 52.5 48.5 26.5 48.5" transform="rotate(90 39.5 36.5)" fill="#fff" />
  </svg>
);

const VideoCard = ({ video }) => {
  const { link, thumbnail, tag, title } = video;
  const [imgSrc, setImgSrc] = React.useState(thumbnail);

  // Handle image load errors with fallback
  const handleImageError = () => {
    // If maxresdefault.jpg fails, try hqdefault.jpg
    if (thumbnail && thumbnail.includes('maxresdefault.jpg')) {
      const fallback = thumbnail.replace('maxresdefault.jpg', 'hqdefault.jpg');
      setImgSrc(fallback);
    }
  };

  return (
    <li className="bg-white rounded-2xl shadow-lg overflow-hidden group transform hover:-translate-y-2 transition-transform duration-300">
      <Link to={link}>
        <div className="relative">
          <figure className="aspect-video">
            <img 
              src={imgSrc} 
              alt={title} 
              className="w-full h-full object-cover"
              onError={handleImageError}
            />
          </figure>
          <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
            <div className="transform group-hover:scale-110 transition-transform duration-300">
              <PlayIcon />
            </div>
          </div>
        </div>
        <div className="p-5">
          <aside className="mb-2">
            <span className="font-bold text-sm text-pink-600 uppercase tracking-wider">{tag}</span>
          </aside>
          <header>
            <h5 className="font-bold text-lg text-gray-800 leading-tight">{title}</h5>
          </header>
        </div>
      </Link>
    </li>
  );
};

export default VideoCard; 